/**
 * @file: index.tsx
 *
 * `FeedThreadScreen` — the navigator binding for the feed thread detail. Wraps
 * the navigation-agnostic `FeedThreadView` (re-exported here), taking the
 * thread identity from the route params and the header title from `title`.
 */

import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { FeedThreadView } from './components/FeedThreadView';

export { FeedThreadView };

export const FeedThreadScreen = wrapNavigatorScreen(
  FeedThreadView,
  ({ route }) => ({
    title: (route.params as { title?: string } | undefined)?.title ?? '消息',
  }),
);
